<script setup>
import { useI18n } from 'vue-i18n';

// Components
import LinkArrow from '@/Components/LinkArrow.vue';

// Icons
import marker from '@i/marker-gray.svg';
import clock from '@i/clock-gray.svg';
import calendar from '@i/calendar-gray.svg';

const { t } = useI18n();

const props = defineProps({
    vacancy: Object,
    href: String,
});
</script>

<template>
    <LinkArrow
        :href="href ? href : '#'"
        class="bg-white group rounded-bl-xl rounded-br-xl'"
        :linkTitle="t('View vacancy')"
    >
        <div class="p-6">
            <div class="flex items-center gap-4">
                <p class="mb-1 text-lg font-black xl:text-2xl">{{ vacancy.page_title }}</p>
            </div>

            <div class="flex gap-4 mb-2">
                <div
                    class="flex items-center gap-2"
                    v-if="vacancy.category"
                    v-for="(cat, i) in vacancy.category"
                    :key="i"
                >
                    <img :src="marker" class="w-4 h-4 md:w-4 md:h-4" alt="icon" />
                    <p class="text-gray-dark">{{ cat.name }}</p>
                </div>

                <div class="flex items-center gap-2" v-if="vacancy.hours">
                    <img :src="clock" class="w-4 h-4 md:w-4 md:h-4" alt="icon" />
                    <p class="text-gray-dark">{{ vacancy.hours }}</p>
                </div>

                <div class="flex items-center gap-2" v-if="vacancy.start_date">
                    <img :src="calendar" class="w-4 h-4 md:w-4 md:h-4" alt="icon" />
                    <p class="text-gray-dark">{{ t('Start date:') }} {{ vacancy.start_date }}</p>
                </div>
            </div>
        </div>
    </LinkArrow>
</template>
